const selectIsRequired = (values) => {
  return Array.isArray(values) ? values.length : values !== void 0 && values !== null;
};
export {
  selectIsRequired as default
};
//# sourceMappingURL=select-required.es.js.map
